import React, { Component } from 'react';

class TestHeader extends Component {
  render() {
    return (
      <div className="test-header">
        <div className="test-header__label">
          <div className="test-header__logo-wrapper">
            <img
                src={`https://ppc.world/quizzes/api${this.props.logo}`}
              alt=""
              className="test__header-logo"
            />
          </div>
          <div className="test-header__text">Партнерский материал</div>
        </div>
      </div>
    );
  }
}

export default TestHeader;
